module.exports = __webpack_public_path__ + "img/selected3-min.fe592a10.png";